export enum TypographyType {
  Normal = 'Normal',
  Secondary = 'Secondary',
  Inverted = 'Inverted',
  Error = 'Error',
  Warning = 'Warning',
}
